import api from './api'

export const settingService = {
  getCompanySettings: () =>
    api.get('/settings/company'),

  getAllSettings: (params?: { group?: string }) =>
    api.get('/settings', { params }),

  updateSetting: (key: string, data: { value: string; description?: string }) =>
    api.put(`/settings/${key}`, data),

  updateCompanySettings: (data: {
    name?: string
    address?: string
    phone?: string
    email?: string
    taxNumber?: string
    logo?: string
    receiptFooter?: string
  }) =>
    api.put('/settings/company/bulk', data),
}
